import styled from 'styled-components';
import { Typography } from '@material-ui/core';

export const Container = styled.div``;

export const DuplicateWarning = styled.div`
    background-color: #ff9800;
    color: #fff;
    padding: 8px 16px;
    border-radius: 4px;
    margin: 8px 0;
    font-size: 14px;
`;

export const Header = styled(Typography)`
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 16px;
    font-weight: 500;

    button {
        cursor: pointer;
        color: gray;
        background: none;
        border: none;
        font-size: 16px;
        font-weight: bold;
        &.active {
            color: black;
        }
    }
`;
